module.exports = __webpack_public_path__ + "static/media/interbank.f827673c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/interbank.png
// module id = 1985
// module chunks = 0